module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0068.jpg?v=24786f5c";